import { connect } from 'react-redux';

import { actionGetInternalAccountList } from 'store/manageAccount/actions';
import {
  actionGetActionHistories,
  actionExportActionHistories,
} from 'store/manager-operation/actions';

import ManagerOperation from './ManagerOperation';

const mapStateToProps = (state) => ({
  actionHistories: state.ManagerOperation.actionHistories,
  totalActionHistories: state.ManagerOperation.totalActionHistories,
  isLoadingGetActionHistories: state.ManagerOperation.isLoadingGetActionHistories,
  isLoadingExportActionHistories: state.ManagerOperation.isLoadingExportActionHistories,
  internalAccountList: state.ManageAccount.internalAccountList,
});

const mapDispatchToProps = (dispatch) => ({
  getActionHistories: (payload) => dispatch(actionGetActionHistories(payload)),
  exportActionHistories: (payload) => dispatch(actionExportActionHistories(payload)),
  getInternalAccountList: (payload) => dispatch(actionGetInternalAccountList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerOperation);
